export * from "./catalog-filter-item";
export * from "./catalog-carousel-item";
export * from "./print-button";

import { CatalogCarouselItemComponent } from "./catalog-carousel-item";
import { CatalogFilterItemComponent } from "./catalog-filter-item";
import { PrintButtonComponent } from "./print-button";

export const CatalogLayoutAtoms = [
  CatalogFilterItemComponent,
  CatalogCarouselItemComponent,
  PrintButtonComponent
];
